export default "__VITE_ASSET__d0bb873a__"